// 一覧が 0 件 / 該当なし時の共通表示。
// 例: <EmptyState title="お知らせはありません" />
import type { ReactNode } from "react";

interface Props {
  title?: string;
  description?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({
  title = "データがありません",
  description,
  action,
  icon,
  className,
}: Props) {
  return (
    <div
      className={`text-center py-10 px-4 text-tora-ink/60 ${className ?? ""}`.trim()}
    >
      {icon && <div className="mb-2 flex justify-center text-3xl">{icon}</div>}
      <p className="text-sm font-medium">{title}</p>
      {description && (
        <p className="text-xs mt-1 text-tora-ink/50">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
